export const PRACTICE = {
  name: "Cabinet Infirmier Victoire Capucins",
  fullName: "Cabinet Infirmier Victoire Capucins · Saint-Jean · Saint-Michel",
  nurses: "Clément Bousquet & Nicolas Pascault",
  phone: "06 21 75 15 98",
  phoneRaw: "+33621751598",
  address: "81 Cours de la Marne, 33800 Bordeaux",
  addressStreet: "81 Cours de la Marne",
  addressCity: "33800 Bordeaux",
  hours: "7j/7 · 8h – 20h",
  rating: "5,0",
  reviewCount: 4,
  mapsUrl:
    "https://www.google.com/maps/place/Cabinet+Infirmier+Victoire+Capucins+St+Jean+St+Michel+-+Cl%C3%A9ment+BOUSQUET+%2F+Nicolas+PASCAULT",
  zones: ["Victoire", "Capucins", "Saint-Jean", "Saint-Michel"],
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1586324304780-c9a5031a3599?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxob21lJTIwbnVyc2UlMjBjYXJpbmclMjBwYXRpZW50fGVufDB8fHx8MTc4Mzg2NjQ1MXww&ixlib=rb-4.1.0&q=85",
  pansements:
    "https://images.unsplash.com/photo-1609840533741-62c180d0be79?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxiYW5kYWdlJTIwbWVkaWNhbCUyMGNhcmluZ3xlbnwwfHx8fDE3ODM4NjY0NTF8MA&ixlib=rb-4.1.0&q=85",
  perfusions:
    "https://images.unsplash.com/photo-1613791716702-9fc08004a5be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxJViUyMGRyaXAlMjBob3NwaXRhbHxlbnwwfHx8fDE3ODI3OTU4OTF8MA&ixlib=rb-4.1.0&q=85",
  bordeaux:
    "https://images.unsplash.com/photo-1556895413-47b9789ba71f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHw0fHxCYXNpbGlxdWUlMjBTYWludC1NaWNoZWwlMjBCb3JkZWF1eCUyMHNwaXJlJTIwdG93ZXJ8ZW58MHx8fHwxNzgzOTczMzY0fDA&ixlib=rb-4.1.0&q=85",
  team: "https://images.unsplash.com/photo-1732194438268-385836aa91c0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwyfHx5b3VuZyUyMG1hbGUlMjBjYXJlZ2l2ZXIlMjBoZWxwaW5nJTIwc2VuaW9yJTIwd29tYW4lMjBob21lJTIwY2FyZXxlbnwwfHx8fDE3ODQwNDI0NDN8MA&ixlib=rb-4.1.0&q=85",
};
